export const intensityOptions = [
  {
    value: '0',
    name: 'Assente',
  },
  {
    value: '1',
    name: 'Lieve',
  },
  {
    value: '2',
    name: 'Moderato',
  },
  {
    value: '3',
    name: 'Forte',
  },
];

export const yesNoOptions = [
  {
    value: '1',
    name: 'Si',
  },
  {
    value: '0',
    name: 'No',
  },
];

export const yesNoOptionsWithNote = ({ yesNote, noNote }: { yesNote: string; noNote: string }) => [
  {
    value: '1',
    name: `Si ${yesNote}`,
  },
  {
    value: '0',
    name: `No ${noNote}`,
  },
];

export const frequency = [
  {
    name: 'No',
    value: '0',
  },
  {
    name: 'Utilizzo saltuario',
    value: '1',
  },
  {
    name: 'Utilizzo continuativo',
    value: '2',
  },
];

export const lifeStyle = [
  { value: '0', name: 'Sedentario' },
  { value: '1', name: 'Moderatamente attivo' },
  { value: '2', name: 'Attivo' },
  { value: '3', name: 'Molto attivo' },
];

export const testType = [
  { value: 'test_completo', name: 'Test completo' },
  { value: 'test_sensor', name: 'Test Sensor' },
  { value: 'test_slim', name: 'Test Slim' },
  { value: 'test_health_metabolism', name: 'Test Health Metabolism' },
  { value: 'test_health_micronutrient', name: 'Test Health Micronutrient' },
  // { value: '6', name: 'Pacchetto salute Base: Sensor + 3 test del microbioma' },
  // { value: '7', name: 'Pacchetto salute Plus: Sensor + 3 test del microbioma' },
  // { value: '8', name: 'Pacchetto salute Premium: Sensor + 3 test del microbioma' },
  // { value: '9', name: 'Dnamo Complete' },
  // { value: '10', name: 'Dnamo Workout' },
  // { value: '11', name: 'Dnamo Nutrition' },
];
